import { useStickySearchParams } from '~/providers/StickySearchParams';

/** In the event the app was loaded with Zendesk given and added parameters, return them. */
export function useZendeskParams() {
  const stickySearchParams = useStickySearchParams();

  const origin = stickySearchParams.get('origin');
  const installationId = stickySearchParams.get('installationId');

  if (!origin || !installationId) return null;

  const { subdomain } =
    origin.match(/^https?:\/\/(?<subdomain>.*)\.zendesk\.com/)?.groups ?? {};

  if (!subdomain) return null;
  return { origin, subdomain, installationId };
}
